const TYPES = ["image/jpeg", "image/png", "image/webp"];
const MAX_BYTES = 15 * 1024 * 1024;

/** Те же ограничения, что на бэкенде (PARTNER_LIMITS): ключ ошибки partnerAssistant.errors.* или null. */
export function validatePhoto(
  file: File
): "photoType" | "photoTooLarge" | null {
  if (!TYPES.includes(file.type)) return "photoType";
  if (file.size > MAX_BYTES) return "photoTooLarge";
  return null;
}
